module.exports = {"Save":"Zapisz","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Wpisz, aby wyszukać (* dla wszystkich)","shipment.packagingSender":"Nadawca","Supplier":"Dostawca"}


//////////////////
// WEBPACK FOOTER
// ./src/core/common/locales/pl.json
// module id = 1354
// module chunks = 1